import React from "react";

const InvoiceIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 23.6499C18.0753 23.6499 23 18.7252 23 12.6499C23 6.5746 18.0753 1.6499 12 1.6499C5.9247 1.6499 1 6.5746 1 12.6499C1 14.4099 1.4136 16.0731 2.1473 17.5482C2.3431 17.9398 2.408 18.3875 2.2947 18.811L1.6402 21.2596C1.57562 21.5019 1.57586 21.7568 1.6409 21.9989C1.70595 22.2411 1.8335 22.4618 2.01078 22.6391C2.18806 22.8164 2.40883 22.944 2.65095 23.009C2.89308 23.074 3.14805 23.0743 3.3903 23.0097L5.8389 22.3552C6.26395 22.2482 6.71343 22.3003 7.1028 22.5015C8.62402 23.259 10.3006 23.6522 12 23.6499Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.0008 16.3163C13.2163 16.3163 14.2008 15.4957 14.2008 14.4837C14.2008 13.4717 13.2163 12.65 12.0008 12.65C10.7853 12.65 9.80078 11.8294 9.80078 10.8163C9.80078 9.8043 10.7853 8.9837 12.0008 8.9837M12.0008 16.3163C10.7853 16.3163 9.80078 15.4957 9.80078 14.4837M12.0008 16.3163V17.05M12.0008 8.9837V8.25M12.0008 8.9837C13.2163 8.9837 14.2008 9.8043 14.2008 10.8163"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default InvoiceIcon;
